import * as React from 'react';
import { Modal } from '@bepure/tarkin';

interface State {
    isOpen: boolean;
}

class ReturnsModal extends React.Component<{}, State> {

    constructor(props: {}) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    public render() {
        return (
            <React.Fragment>
                <button id={'returns_modal-returns_refund_policy_cta'} className="text text--clear_button text--link text--link--primary text--hide_link" onClick={this.handleOpen}>
                    Returns, Refunds &amp; Cancellation Policy
            </button>
                <Modal
                    open={this.state.isOpen}
                    contentClassName=""
                    isSmall={true}
                    hasBackground={true}
                    handleClose={this.handleClose}
                >
                    <div className="flex flex--align_center flex--column flex--justify_center padding">
                        <div className="text text--center text--heading-2 margin--small">
                            Eve Returns, Refunds & Cancellation Policy
                        </div>
                        <p className="text text--center text--body margin--small">
                            All returns need to be made within 30 days of purchase.
                        </p>
                        <p className="text text--center text--body margin--small">
                                Damaged products can be returned for a full refund. Please contact our support team to arrange your return on <a className="text text--link" href="tel:0800367383"> 0800 FOR EVE (0800 367 383)</a> or email them at <a className="text text--link" href="mailto:info@evewellnessco.com">info@evewellnessco.com</a>.
                            </p>
                        <p className="text text--center text--body margin--small">
                            Once received at the Warehouse, a full refund will be processed for the test. Please note, cancellation and return fees apply and are at the discretion of the Eve team.
                        </p>
                        <p className="text text--center text--body margin--small">
                            Refunds may take 6 - 10 business days to process and show in your account. Refunds will be processed to the same credit card used for the purchase.
                        </p>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }

    private handleClose = () => {
        this.setState({
            isOpen: false,
        });
    }

    private handleOpen = () => {
        this.setState({
            isOpen: true,
        });
    }
}

export default ReturnsModal;
